var Pixel = Pixel || {};

Pixel.Bing = (function (PixelBase) {
    var Bing = PixelBase.extend({
        initialize: function (opts) {
            opts = opts || {};
            this._currency = opts.currency;
        },

        pageView: function () {
        },

        _getAPI: function () {
            return window.uetq || function () { };
        },

        purchaseSuccess: function (opts) {
            var data = opts.OrderInfoResult || {};

            this._getAPI().push('event', 'purchase', { 'revenue_value': data.Total, "currency": this._currency });
        }
    });

    return Bing;
})(Pixel.PixelBase);

!function (Pixel, GlobalSettings) {
    if (!GlobalSettings.BEnabled) {
        return;
    }

    new Pixel.Bing({
        id: GlobalSettings.PID
    });
}(Pixel, GlobalSettings);
